import moment from 'moment'
import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/Sales'

export default {
  namespaced: true,
  state: {
    loading: false,
    sales: {
      data: [],
      grandTotals: {
        sales: 0,
      },
    },
    brands: {
      data: [],
      grandTotal: {
        sales: 0,
        connections: 0,
        allocateConnections: 0,
        stockConnections: 0,
        stocks: 0,
        salesChart: {
          series: [],
          categories: [],
          colors: [],
        },
        connectionsChart: {
          series: [],
          categories: [],
          colors: [],
        },
        stocksChart: {
          series: [],
          categories: [],
          colors: [],
        },
      },
    },
    cumulatives: {
      data: [],
      grandTotals: {
        sales: 0,
        chartData: {
          categories: [],
          series: [],
        },
      },
    },
    lastMonth: {
      data: [],
      grandTotals: {
        connections: 0,
      },
    },
    newConnections: {
      data: [],
      grandTotals: {
        connections: 0,
      },
    },
    connectionDetail: {
      data: [],
      dataCount: 0,
    },
    interviews: {
      data: [],
      grandTotals: {
        daily: 0,
        monthly: 0,
      },
    },
    /* Filter Params */
    salesParams: {
      sdate: `${moment().format('YYYY-MM')}-01`,
      edate: moment().format('YYYY-MM-DD'),
    },
    brandsParams: {
      sdate: `${moment().format('YYYY-MM')}-01`,
      edate: moment().format('YYYY-MM-DD'),
    },
    cumulativesParams: {
      sdate: `${moment().format('YYYY')}-01-01`,
      edate: moment().format('YYYY-MM-DD'),
    },
    chartData: [],
  },
  getters: {
    loading(state) {
      return state.loading
    },
    sales(state) {
      return state.sales
    },
    brands(state) {
      return state.brands
    },
    cumulatives(state) {
      return state.cumulatives
    },
    lastMonth(state) {
      return state.lastMonth
    },
    newConnections(state) {
      return state.newConnections
    },
    connectionDetail(state) {
      return state.connectionDetail
    },
    interviews(state) {
      return state.interviews
    },
    /* Filter Params */
    salesParams(state) {
      return state.salesParams
    },
    brandsParams(state) {
      return state.brandsParams
    },
    cumulativesParams(state) {
      return state.cumulativesParams
    },
    getChartData(state) {
      return state.chartData
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_SALES(state, data) {
      state.sales = data
    },
    SET_BRANDS(state, data) {
      state.brands = data
    },
    SET_CUMULATIVES(state, data) {
      state.cumulatives = data
    },
    SET_LAST_MONTH(state, data) {
      state.lastMonth = data
    },
    SET_NEW_CONNECTIONS(state, data) {
      state.newConnections = data
    },
    SET_CONNECTION_DETAIL(state, data) {
      state.connectionDetail = data
    },
    SET_INTERVIEWS(state, data) {
      state.interviews = data
    },
    SET_CHART_DATA(state, data) {
      state.chartData = data
    },
    /* RESET MUTATIONS */
    RESET_SALES(state) {
      state.sales = {
        data: [],
        grandTotals: {
          sales: 0,
        },
      }
    },
    RESET_BRANDS(state) {
      state.brands = {
        data: [],
        grandTotal: {
          sales: 0,
          connections: 0,
          allocateConnections: 0,
          stockConnections: 0,
          stocks: 0,
          salesChart: {
            series: [],
            categories: [],
            colors: [],
          },
          connectionsChart: {
            series: [],
            categories: [],
            colors: [],
          },
          stocksChart: {
            series: [],
            categories: [],
            colors: [],
          },
        },
      }
    },
    RESET_CUMULATIVES(state) {
      state.cumulatives = {
        data: [],
        grandTotals: {
          sales: 0,
          chartData: {
            categories: [],
            series: [],
          },
        },
      }
    },
    RESET_LAST_MONTH(state) {
      state.lastMonth = {
        data: [],
        grandTotals: {
          connections: 0,
        },
      }
    },
    RESET_NEW_CONNECTIONS(state) {
      state.newConnections = {
        data: [],
        grandTotals: {
          connections: 0,
        },
      }
    },
    RESET_CONNECTION_DETAIL(state) {
      state.connectionDetail = {
        data: [],
        dataCount: 0,
      }
    },
    RESET_INTERVIEWS(state) {
      state.interviews = {
        data: [],
        grandTotals: {
          daily: 0,
          monthly: 0,
        },
      }
    },
  },
  actions: {
    getSales({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_SALES')
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/sales`, data)
        .then(response => {
          commit('SET_SALES', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    getBrands({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_BRANDS')
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/sales/brands`, data)
        .then(response => {
          commit('SET_BRANDS', response.data)
          commit('SET_CHART_DATA', response.data.chartData)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    getCumulatives({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_CUMULATIVES')
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/sales/cumulatives`, data)
        .then(response => {
          commit('SET_CUMULATIVES', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    getLastMonth({ commit }, params) {
      commit('RESET_LAST_MONTH')
      const data = JSON.stringify(params)
      return axiosIns
        .post(`${ROOT_URL}/sales/lastMonth`, data)
        .then(response => {
          commit('SET_LAST_MONTH', response.data)
          return response.data
        })
        .catch(error => console.error(error))
    },
    getNewConnections({ commit }, params) {
      commit('RESET_NEW_CONNECTIONS')
      const data = JSON.stringify(params)
      return axiosIns
        .post(`${ROOT_URL}/sales/newConnections`, data)
        .then(response => {
          commit('SET_NEW_CONNECTIONS', response.data)
          return response.data
        })
        .catch(error => console.error(error))
    },
    getConnectionDetail({ commit }, params) {
      commit('RESET_CONNECTION_DETAIL')
      const data = JSON.stringify(params)
      return axiosIns
        .post(`${ROOT_URL}/sales/connectionDetail`, data)
        .then(response => {
          commit('SET_CONNECTION_DETAIL', response.data)
          return response.data
        })
        .catch(error => console.error(error))
    },
    getInterviews({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_INTERVIEWS')
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/interviews/brands`, data)
        .then(response => {
          commit('SET_INTERVIEWS', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
  },
}
